module.exports = __webpack_public_path__ + "static/first-step-apartados-9774baf99c50bc7d71c853da89d810a0.svg";